export var DeviceKind;
(function (DeviceKind) {
    DeviceKind["videoInput"] = "videoinput";
    DeviceKind["audioInput"] = "audioinput";
    DeviceKind["audioOutput"] = "audiooutput";
})(DeviceKind || (DeviceKind = {}));
export var DeviceFacingMode;
(function (DeviceFacingMode) {
    DeviceFacingMode["user"] = "user";
    DeviceFacingMode["environment"] = "environment";
})(DeviceFacingMode || (DeviceFacingMode = {}));
export var DeviceKindNormalized;
(function (DeviceKindNormalized) {
    DeviceKindNormalized["videoInput"] = "videoInput";
    DeviceKindNormalized["audioInput"] = "audioInput";
    DeviceKindNormalized["audioOutput"] = "audioOutput";
})(DeviceKindNormalized || (DeviceKindNormalized = {}));
// kept old string to support already stored
export const CURRENT_DEVICES_STORAGE_KEY = 'devicesInfo';
export const DEVICE_CHANGE_EVENT = 'devicechange';
